module.exports = __webpack_public_path__ + "step5.325274fe48e76517c33d5c6da713c3b9.png";